import { AlertTriangle, MessageCircle, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ProactiveInterventionCardProps {
  missedCount: number;
  message?: string;
  onDismiss: () => void;
}

export function ProactiveInterventionCard({ missedCount, message, onDismiss }: ProactiveInterventionCardProps) {
  const navigate = useNavigate();

  const handleTalkToCoach = () => {
    navigate('/coach', {
      state: {
        draft_message: "I've been missing some sessions lately and would like to discuss adjusting my training plan.",
        context: 'intervention_redirect',
      },
    });
  };

  const displayMessage = message ??
    `You've missed ${missedCount} sessions recently. Want to discuss adjusting your plan with your coach?`;

  return (
    <div className="relative rounded-lg border border-white/[0.06] bg-white/[0.02] backdrop-blur-sm overflow-hidden">
      <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-amber-500 shadow-[0_0_8px_hsl(35,90%,55%,0.4)]" />
      <div className="p-5 pl-6">
        <div className="flex items-start justify-between gap-3 mb-3">
          <div className="flex items-center gap-3">
            <AlertTriangle className="h-5 w-5 text-amber-400 shrink-0" strokeWidth={1.5} />
            <span className="text-[10px] font-mono tracking-[0.15em] uppercase text-amber-400/70">
              Missed sessions
            </span>
          </div>
          <button
            onClick={onDismiss}
            className="text-slate-600 hover:text-slate-400 transition-colors p-1 -m-1"
            aria-label="Dismiss"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <p className="text-[13px] font-mono text-slate-300 mb-4 leading-relaxed">
          {displayMessage}
        </p>

        <div className="flex items-center gap-3">
          <button
            onClick={handleTalkToCoach}
            className="flex items-center gap-2 px-4 py-2 rounded-md bg-amber-500/10 border border-amber-500/20 text-amber-400 text-[12px] font-mono tracking-wider uppercase hover:bg-amber-500/20 transition-colors"
          >
            <MessageCircle className="h-3.5 w-3.5" />
            Talk to Coach
          </button>
          <button
            onClick={onDismiss}
            className="px-4 py-2 rounded-md text-slate-500 text-[12px] font-mono tracking-wider uppercase hover:text-slate-400 hover:bg-white/[0.03] transition-colors"
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
}
